import * as React from "react"
export function NumericInput({
  onIncrement,
  onDecrement,
  className,
  disabled,
  ...props
}) {
  return (
    <div className="border border-[#e0e0e0] max-w-[124px] shadow-sm font-display">
      <button
        type="button"
        disabled={disabled}
        aria-label="Decrement"
        onClick={onDecrement}
        className="p-5 leading-[0] text-darkgrey hover:text-red duration-300 text-lg"
      >
        <span>-</span>
      </button>
      <input
        disabled={disabled}
        type="numeric"
        className="w-[25px] text-center font-display focus:outline-none text-lg"
        {...props}
      />
      <button
        type="button"
        disabled={disabled}
        aria-label="Increment"
        onClick={onIncrement}
        className="p-5 leading-[0] text-darkgrey hover:text-red duration-300 text-lg"
      >
        <span>+</span>
      </button>
    </div>
  )
}